export default "__VITE_ASSET__D0gL60hF__"